<template lang="pug">
  transition(name="fade")
    .modal(v-if="show")
      .modal__backdrop(@click="closeModal()")

      .modal__dialog
        .modal__header
          button(type="button" class="modal__close focus:outline-none" @click="closeModal()")
            i.fal.fa-times.text-3xl

        .modal__body.max-h-modal-content.overflow-auto
          slot(name="body")

</template>

<script>
export default {
  name: "Modal",
  data() {
    return {
      show: false
    };
  },
  methods: {
    closeModal() {
      this.show = false;
      document.querySelector("body").classList.remove("overflow-hidden-body");
      document.querySelector("html").classList.remove("overflow-hidden-html");
    },
    openModal() {
      this.show = true;
      document.querySelector("body").classList.add("overflow-hidden-body");
      document.querySelector("html").classList.add("overflow-hidden-html");
    }
  }
};
</script>
